
import React from 'react';
import { motion } from 'framer-motion';
import { Language } from '../App';

interface HeroProps {
  lang: Language;
}

const Hero: React.FC<HeroProps> = ({ lang }) => {
  const content = {
    pt: {
      title: "Seu Token num",
      highlight: "Ecossistema Real.",
      desc: "Infraestrutura completa para integração, pré-venda e ativação com usuários reais via PIX e Web3.",
      btnPrimary: "Listar Projeto",
      btnSecondary: "Falar com o Time"
    },
    en: {
      title: "Your Token in a",
      highlight: "Real Ecosystem.",
      desc: "Complete infrastructure for integration, pre-sale and activation with real users via local payments and Web3.",
      btnPrimary: "List Project",
      btnSecondary: "Talk to Team"
    }
  };

  const t = content[lang];

  return (
    <section className="relative pt-32 pb-16 md:pt-48 md:pb-28 overflow-hidden hex-bg bg-gradient-hero">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex flex-col md:flex-row items-center justify-between">
        <motion.div 
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="md:w-3/5 text-center md:text-left z-10"
        >
          <h1 className="text-4xl md:text-6xl lg:text-8xl font-black text-white leading-[1.1] mb-6 uppercase">
            {t.title} <br/><span className="gradient-text">{t.highlight}</span>
          </h1>
          <p className="text-lg md:text-xl text-zinc-400 mb-10 max-w-xl mx-auto md:mx-0 leading-relaxed font-medium">
            {t.desc}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
            <a 
              href="https://t.me/Ceo_RHT"
              target="_blank"
              rel="noopener noreferrer"
              className="gradient-bg hover:brightness-110 text-white px-8 py-4 rounded-xl text-sm font-black uppercase tracking-widest transition-all transform hover:scale-105 btn-glow text-center"
            >
              {t.btnPrimary}
            </a>
            <a 
              href="https://t.me/Ceo_RHT"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white/5 hover:bg-white/10 text-white px-8 py-4 rounded-xl text-sm font-bold uppercase tracking-widest transition-all border border-white/10 backdrop-blur-sm text-center"
            >
              {t.btnSecondary}
            </a>
          </div>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, scale: 0.9, rotateY: 20 }}
          animate={{ opacity: 1, scale: 1, rotateY: 0 }}
          transition={{ duration: 1.2, delay: 0.2 }}
          className="md:w-2/5 mt-16 md:mt-0 relative"
        >
          <div className="relative z-20 float-animation">
            <div className="w-[280px] md:w-[320px] h-[580px] md:h-[650px] mx-auto bg-black rounded-[3rem] border-[10px] border-zinc-900 relative overflow-hidden red-glow shadow-[0_0_100px_rgba(249,115,22,0.15)]">
              {/* Official Interface Mockup */}
              <div className="absolute inset-0 bg-zinc-950">
                <img 
                  src="https://i.imgur.com/TwLezFg.jpeg" 
                  alt="DeFi Bank Wallet Interface" 
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-7 bg-zinc-900 rounded-b-2xl z-30 flex items-center justify-center">
                  <div className="w-10 h-1 bg-zinc-800 rounded-full"></div>
                </div>
              </div>
              <div className="absolute inset-0 pointer-events-none bg-gradient-to-tr from-white/5 to-transparent opacity-30 z-20"></div>
            </div>
            <div className="absolute -top-10 -right-10 w-64 h-64 bg-orange-600/10 rounded-full blur-[100px]"></div>
            <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-pink-600/10 rounded-full blur-[100px]"></div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
